import React, { useState, useEffect } from "react";
import format from "date-fns/format";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import { Pagination } from "../../../Utils";
import { GetFeedbackPaginate } from "../../../Services/Api/feedback";

const ListFeedback = () => {
  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [feedback, setFeedback] = useState([]);

  const GetFeedback = async (limitO = "", pageO = "") => {
    setIsLoading(true);
    await GetFeedbackPaginate({ limit: limitO, page: pageO })
      .then((res) => {
        setIsLoading(false);
        if (res?.data?.data?.totalRecords > 0) {
          setFeedback(res?.data?.data?.feedbacks);
          setTotalRecords(res?.data?.data?.totalRecords);
        } else {
          setFeedback([]);
          setTotalRecords(0);
        }
      })
      .catch((err) => {
        setFeedback([]);
        setTotalRecords(0);
        setIsLoading(false);
      });
  };

  const handlePageChange = async (e, pageNew) => {
    setPage(pageNew);
    await GetFeedback(limit, pageNew);
  };

  const handleLimitChange = async (event) => {
    setLimit(parseInt(event.target.value, 10));
    setPage(0);
    await GetFeedback(parseInt(event.target.value, 10), 0);
  };

  useEffect(() => {
    GetFeedback(limit, page);
  }, [limit, page]);

  return (
    <>
      <Helmet>
        <title>CPay | Admin - Feedback</title>
      </Helmet>
      <div className="page-wrapper">
        <div className="content container-fluid">
          <div className="page-header">
            <div className="row align-items-center">
              <div className="col">
                <h3 className="page-title">Feedback</h3>
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/admin/dashboard">Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item active">Feedback</li>
                </ul>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12">
              <div className="card card-table">
                <div className="card-body">
                  <div className="table-responsive custom-pagination">
                    <table className="table table-center table<img<image-hover datatable">
                      <thead className="thead-light">
                        <tr>
                          <th>User Role</th>
                          <th>User Name</th>
                          <th>User Email</th>
                          <th>Topic</th>
                          <th>Message</th>
                          <th>Created On</th>
                        </tr>
                      </thead>
                      <tbody>
                        {!isLoading && (
                          <>
                            {feedback.map((contact_us, index) => (
                              <tr key={`admin-feedback-list-${index}`}>
                                <td>{contact_us?.user_role || "-"}</td>
                                <td>{contact_us?.user?.name || "-"}</td>
                                <td>{contact_us?.email || "-"}</td>
                                <td>{contact_us?.topic || "-"}</td>
                                <td style={{ whiteSpace: 'break-spaces' }}>{contact_us?.message || "-"}</td>
                                <td>
                                  {format(
                                    new Date(contact_us?.createdAt),
                                    "dd MMMM, yyyy"
                                  )}
                                </td>
                              </tr>
                            ))}
                            {feedback.length === 0 && (
                              <tr>
                                <td colSpan={6}>No Records Found.</td>
                              </tr>
                            )}
                          </>
                        )}

                        {isLoading && (
                          <tr>
                            <td align="center" colSpan={6}>
                              Loading...
                            </td>
                          </tr>
                        )}

                        <Pagination
                          totalItem={totalRecords}
                          itemsPerPage={limit}
                          page={page}
                          handleChangePage={handlePageChange}
                          handleChangeRowsPerPage={handleLimitChange}
                          colSpan={6}
                        />
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            <div className="container-fluid absolute mb-4">
              <footer className="text-center text-lg-start">
                <div className="text-center">Powered by Alsaffron System.</div>
              </footer>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ListFeedback;
